import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { FeeLevelFeatureComponent } from './feature/fee-level-feature.component';
const log = new LoggingService();

export const FeeLevelRoute: Ng2StateDeclaration = {
    name: 'feeestructure',
    url: '/feeestructure',
    data: { requiresAuth: true },

    component: FeeLevelFeatureComponent
};
